/* eslint-disable */
import axios from "axios";
import '../utils/axios.interceptor';
import { urlCoreBack } from "../../project/configs/config";

const epName = "v1/entrega-articulo/";
const nameItemText = "Entrega de Artículos";
const itemGender = "F";
const elLa = itemGender === "M" ? "el" : "la";
const unUna = itemGender === "M" ? "un" : "una";
//
// #############################################################################
//
export const getEntregaArticulos = async (parIdGcEntrega) => {
	let _errorMessage = `No fue posible obtener los detalles de la Entrega de Artículos`;
	let _epName = "v1/entrega-articulo/";

	let _params = {
		id_gc_entrega: parIdGcEntrega,
	};

	try {
		const response = await axios({
			method: "GET",
			url: `${urlCoreBack}${_epName}`,
			params: _params,
		});

		if (response.status === 200) {
			let _error = "status" in response.data && response.data.status === "error";
			if (!_error) {
				// si no hay error controlado
				response.ok = true;
				return response;
			}
		}

		// si hay algun error controlado

		console.log(_errorMessage);
		console.log(response);

		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	} catch (error) {
		console.log(_errorMessage);
		if (error.response) {
			// The request was made and the server responded with a status code that falls out of the range of 2xx
			console.log(error.response);
		} else if (error.request) {
			// The request was made but no response was received
			// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
			// http.ClientRequest in node.js
			console.log(error.request);
		} else {
			// Something happened in setting up the request that triggered an Error
			console.log(error);
		}
		let response = {};
		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	}
};
//
// #############################################################################
//
export const saveEntregaArticulos = async (parEntregaArticulos) => {
	let _errorMessage = `No fue posible guardar ${elLa} ${nameItemText}`;

	parEntregaArticulos.id_area = localStorage.getItem("id_area_ventas");
	parEntregaArticulos.id_usuario = localStorage.getItem("id_usuario");

	try {
		const response = await axios({
			method: "POST",
			url: `${urlCoreBack}${epName}`,
			data: parEntregaArticulos,
		});

		if (response.status === 200) {
			let _error = "status" in response.data && response.data.status === "error";
			if (!_error) {
				// si no hay error controlado
				response.ok = true;
				response.messageText = "Entrega de artículos guardada";
				return response;
			}
		}

		// si hay algun error controlado

		console.log(_errorMessage);
		console.log(response);
		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	} catch (error) {
		console.log(_errorMessage);
		if (error.response) {
			// The request was made and the server responded with a status code that falls out of the range of 2xx
			console.log(error.response);
		} else if (error.request) {
			// The request was made but no response was received
			// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
			// http.ClientRequest in node.js
			console.log(error.request);
		} else {
			// Something happened in setting up the request that triggered an Error
			console.log(error);
		}
		let response = {};
		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	}
};
//
// #############################################################################
//
export const invalidateEntregaArticulos = async (parAnulacionEntrega) => {
	let _errorMessage = `No fue posible anular ${elLa} ${nameItemText}`;

	parAnulacionEntrega.id_area = localStorage.getItem("id_area_ventas");
	parAnulacionEntrega.id_usuario = localStorage.getItem("id_usuario");

	try {
		const response = await axios({
			method: "DELETE",
			url: `${urlCoreBack}${epName}`,
			params: parAnulacionEntrega,
		});

		if (response.status === 200) {
			let _error = "status" in response.data && response.data.status === "error";
			if (!_error) {
				// si no hay error controlado
				response.ok = true;
				response.messageText = `${nameItemText}` + " anulado";
				response.messageSeverity = "success";
				return response;
			}

			// si hay error controlado

			console.log(_errorMessage);
			console.log(response);

			response.messageText = _errorMessage;
			response.ok = false;
			response.messageSeverity = "error";
			return response;
		}
	} catch (error) {
		console.log(_errorMessage);
		if (error.response) {
			// The request was made and the server responded with a status code that falls out of the range of 2xx
			console.log(error.response);
		} else if (error.request) {
			// The request was made but no response was received
			// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
			// http.ClientRequest in node.js
			console.log(error.request);
		} else {
			// Something happened in setting up the request that triggered an Error
			console.log(error);
		}
		let response = {};
		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	}
};